<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="1260">
      <v-card class="px-0" height="700px" style="overflow: hidden">
        <v-row class="d-flex flex-column bg-light ma-0">
          <v-col cols="12" class="text-right pt-2 pb-0">
            <v-btn icon class="mt-2 mr-3" @click="handleClose()">
              <v-icon color="icon">mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-card flat max-width="1250">
            <v-row class="align-center bg-light px-7">
              <v-col cols="12" class="px-9">
                <v-row>
                  <v-col cols="9" class="pb-0">
                    <h2 class="pl-3">
                      {{ $t('message.simpleAndTransparentPlans') }}
                    </h2>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="text-left px-7">
              <v-col cols="12" class="px-9 pt-1">
                <v-row>
                  <v-col cols="9" class="pt-0">
                    <span class="my-3 pl-3">
                      {{ $t('message.allTypePlans') }}
                    </span>
                  </v-col>

                  <v-col cols="3" class="pr-10 text-right">
                    <span>
                      <a
                        href="https://www.pandavideo.com.br/#plans"
                        target="_blank"
                      >
                        {{ $t('message.whatIsMyIdealPlan') }}
                      </a>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>

          <template v-if="!loading">
            <template v-if="error">
              <div class="container-carousel px-9 mt-3">
                <v-row class="align-stretch px-10 pt-3">
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="12" class="card-title-benefits">
                        {{ $t('message.benefits') }}
                      </v-col>

                      <v-col
                        cols="12"
                        class="card-details-benefits text-left pl-2"
                      >
                        <v-avatar color="lighter" size="25" class="mr-2">
                          <v-icon size="14" color="primary">mdi-server</v-icon>
                        </v-avatar>
                        {{ $t('message.storage') }}
                      </v-col>
                      <v-col
                        cols="12"
                        class="card-details-benefits text-left pl-2"
                      >
                        <v-avatar color="lighter" size="25" class="mr-2">
                          <v-icon size="20" color="primary"
                            >mdi-swap-horizontal</v-icon
                          >
                        </v-avatar>
                        {{ $t('message.traffic') }}
                      </v-col>
                      <v-col
                        cols="12"
                        class="card-details-benefits text-left pl-2"
                      >
                        <v-avatar color="lighter" size="25" class="mr-2">
                          <v-icon size="20" color="primary"
                            >mdi-currency-usd</v-icon
                          >
                        </v-avatar>
                        <strong>{{ $t('message.value') }}</strong>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="10"
                    :class="{ currentStateGradient }"
                    class="pa-0 col-carousel-prices"
                  >
                    <v-sheet
                      class="mx-auto row-carousel-prices"
                      max-width="1024"
                    >
                      <v-slide-group
                        v-model="model"
                        class="pa-0 d-block slide-group slide-group-prices"
                        active-class="chosen-card"
                        transition="scale-transition"
                        center-active
                        max="0"
                        show-arrows="mobile"
                      >
                        <template v-slot:next>
                          <!--  -->
                          <span
                            class="slide-next"
                            @click="
                              currentStateGradient = !currentStateGradient
                            "
                          >
                            <v-img
                              src="../../assets/arrow_carousel.svg"
                              width="20px"
                              height="20px"
                              class="slide-next-svg"
                            >
                            </v-img>
                          </span>
                        </template>

                        <v-slide-item
                          v-for="(plan, i) in plans"
                          :key="i"
                          v-bind:class="
                            getCurrentPlan(plan.id) ? activeClass : ''
                          "
                        >
                          <v-card
                            :color="i === selectedItem ? 'lighter' : ''"
                            class="mb-8"
                            elevation="0"
                          >
                            <v-row
                              no-gutters
                              class="d-flex flex-column align-center justify-center"
                            >
                              <v-card-text class="pa-0">
                                <div class="card-price">
                                  <v-col
                                    cols="12"
                                    class="d-flex flex-row align-center pa-0"
                                  >
                                    <span
                                      v-if="getCurrentPlan(plan.id)"
                                      class="card-title-prices"
                                      style="padding: 22px 0"
                                    >
                                      <h6
                                        style="
                                          color: #ffffff;
                                          font-size: 12px;
                                          text-transform: normal;
                                        "
                                      >
                                        {{ $t('message.currentPlan') }}
                                      </h6>
                                      {{ plan.title }}
                                    </span>

                                    <span v-else class="card-title-prices">
                                      {{ plan.title }}
                                    </span>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    class="d-flex flex-row align-center pa-0"
                                  >
                                    <span class="card-details-prices">
                                      {{ calcBytes(plan.storage) }}
                                    </span>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    class="d-flex flex-row align-center pa-0"
                                  >
                                    <span class="card-details-prices">
                                      {{ calcBytes(plan.traffic) }}
                                    </span>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    class="d-flex flex-row align-center justify-center pa-0"
                                  >
                                    <span class="card-details-prices">
                                      <strong
                                        >R$ {{ formatPrice(plan.price) }}
                                      </strong>
                                      <!--/ {{type}} -->
                                    </span>
                                  </v-col>
                                </div>
                                <v-col
                                  cols="12"
                                  class="d-flex flex-row align-center justify-center pb-2"
                                  v-if="checkingUpgrade(plan.storage)"
                                >
                                  <v-row>
                                    <v-col cols="12">
                                      <span
                                        style="color: red"
                                        class="d-block mt-2"
                                      >
                                        {{ $t('message.downgradeUnavailable') }}
                                      </span>
                                    </v-col>
                                  </v-row>
                                </v-col>

                                <v-col
                                  cols="12"
                                  class="d-flex flex-row align-center justify-center pb-2"
                                  v-else
                                >
                                  <v-btn
                                    v-if="getCurrentPlan(plan.id)"
                                    block
                                    large
                                    width="160px"
                                    height="48px"
                                    color="#4874F1"
                                    class="card-button-current-plan"
                                  >
                                    {{ $t('message.currentPlan') }}
                                    <v-icon
                                      color="#304FA9"
                                      size="16"
                                      v-text="'mdi-check-all'"
                                    ></v-icon>
                                  </v-btn>

                                  <v-btn
                                    v-else
                                    block
                                    large
                                    width="160px"
                                    height="48px"
                                    color="#4874F1"
                                    class="card-button-prices"
                                    @click="handleCheckout(plan)"
                                  >
                                    {{ $t('message.doOneUpgrade') }}
                                  </v-btn>
                                </v-col>
                              </v-card-text>
                            </v-row>
                          </v-card>
                        </v-slide-item>

                        <template v-slot:prev>
                          <span
                            class="slide-prev"
                            @click="
                              currentStateGradient = !currentStateGradient
                            "
                          >
                            <v-img
                              src="../../assets/arrow_carousel.svg"
                              width="20px"
                              height="20px"
                              class="slide-next-svg"
                            >
                            </v-img>
                          </span>
                        </template>
                      </v-slide-group>
                    </v-sheet>
                  </v-col>
                </v-row>
              </div>
            </template>

            <template v-else>
              <v-card
                class="d-flex flex-row justify-center align-center"
                height="700px"
                width="100%"
              >
                <v-row no-gutters justify="center" align="center">
                  <v-col
                    cols="8"
                    class="d-flex justify-center align-center mb-3"
                  >
                    <span class="text-h5">{{
                      $t('message.errors.failedToAsyncPlans')
                    }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters align="center" justify="center">
                      <v-btn
                        color="primary"
                        class="ma-2 ml-3 white--text"
                        rounded
                        @click="loadPlanData"
                      >
                        <span class="mx-2">{{ $t('message.tryAgain') }}</span>
                        <v-icon right dark> mdi-cached </v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </template>

          <template v-else>
            <v-card
              class="d-flex flex-row justify-center align-center"
              height="400px"
              width="100%"
              flat
            >
              <v-progress-circular
                :size="80"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-card>
          </template>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import planApi from '../../services/planApi'
import prettyBytes from 'pretty-bytes'
//import i18n from '@/translations/lang'
import plansApi from '../../services/planApi'
import userApi from '../../services/userApi'

export default {
  name: 'Upgrade',
  components: {},
  data: () => ({
    open: false,
    model: false,
    isActive: false,
    currentStateGradient: false,
    activeClass: 'chosen-card',
    plansData: [],
    type: '',
    loading: true,
    error: false,
  }),
  mounted() {
    this.$root.$on('Upgrade', () => {
      this.open = true
      this.type = 'month'
      this.currentStateGradient = false
      this.loadProducts()
      this.loadPlanData()
    }),
      this.$root.$on('closeUpgrade', () => {
        this.open = false
      })
  },
  beforeDestroy() {
    this.$root.$off('Upgrade')
    this.$root.$off('closeUpgrade')
  },
  computed: {
    ...mapState('user', {
      userPlan: 'userPlanInfo',
    }),
    plans() {
      const recurring_type = 'month'
      const plansFiltered = this.plansData.filter((plan) =>
        plan.prices.find((price) => price.recurring.interval === recurring_type)
      )
      const plansResponse = plansFiltered.map((plan) => {
        const price = plan.prices.find(
          (price) => price.recurring.interval === recurring_type
        )
        const finalPlan = {
          title: plan.name,
          price: (price.unit_amount / 100).toFixed(2),
          storage: plan.metadata.storage,
          traffic: plan.metadata.transfer,
          value: price.id,
          id: plan.id,
        }
        return finalPlan
      })
      let ascendingPlans = plansResponse.sort(
        (a, b) => parseFloat(a.price) - parseFloat(b.price)
      )
      return ascendingPlans
    },
    selectedItem() {
      const userPlanName = this.userPlan?.name || 'NONE'
      return this.plans.map((plan) => plan.title).indexOf(userPlanName)
    },
  },
  methods: {
    handleCheckout(plan) {
      this.$root.$emit('CheckoutModal', plan)
    },
    handleClose() {
      this.open = false
    },
    calcBytes(planStorage) {
      let bytes = 0
      planStorage > 1024
        ? (bytes = (planStorage / 1024) * 1e12)
        : (bytes = planStorage * 1e9)
      return `${prettyBytes(bytes, { maximumFractionDigits: 0 })}`
    },
    formatPrice(price) {
      return parseFloat(price).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    checkingUpgrade(storagePlan) {
      const currentStorage = this.userPlan?.limit?.storage / 1024
      return currentStorage > parseInt(storagePlan) ? true : false
    },
    getCurrentPlan(plan) {
      const currentPlan = this.userPlan?.subscription?.id
      if (plan == currentPlan) {
        this.isActive = true
        return true
      }
    },
    async loadPlanData() {
      this.loading = true
      try {
        const [ret, userLimit] = await Promise.all([
          planApi.getSubscription(),
          userApi.getUserLimit(),
        ])
        this.UPDATE_USER_PLAN_INFO({
          addons: ret.data.addons,
          subscription_id: ret.data.subscription_id,
          subscription: ret.data.subscriptions,
          limit: userLimit.data,
          planId: ret.data.subscriptions.id,
          type_payment: ret.data.type_payment,
          subscription_metadata: ret.data.subscription_metadata ?? {},
          user: {
            name: ret.data.name,
            email: ret.data.email,
          },
        })
      } catch (e) {
        this.error = true
        if (e) {
          userApi.fixUserLimit()
        }
      }
      this.$root.$emit('showAccountWarning')
      this.loading = false
    },
    async loadProducts() {
      try {
        const ret = await plansApi.getPlans()
        this.plansData = ret.data.plans
      } catch (e) {
        console.log(e)
      }
    },
    async fixUserLimit() {
      try {
        await userApi.fixUserLimit()
      } catch (e) {
        this.error = true
      }
    },
  },
}
</script>

<style scoped>
.bg-light {
  background: #ffffff;
}
.v-item-group.v-bottom-navigation {
  box-shadow: none;
  width: auto;
  justify-content: flex-end;
}

.row-carousel-prices .v-item-group {
  transition: none !important;
}

.btn-plan-type {
  background: #efeffd !important;
  color: #4874f1 !important;
  padding: 0 !important;
}

.btn-plan-type-active {
  background: #4874f1 !important;
  box-shadow: 0px 6px 2px -4px rgba(14, 14, 44, 0.1),
    inset 0px -1px 0px rgba(14, 14, 44, 0.4) !important;
  color: #fff !important;
  width: 100px !important;
  cursor: default;
  margin-right: -4px;
  z-index: 99;
  pointer-events: none;
  -webkit-pointer-events: none;
}

.container-carousel {
  display: block;
  width: 100%;
  overflow: hidden;
}

.card-title-benefits {
  padding: 33px 0 33px 25px;
  margin-top: 7px;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  background: #e3e7fc;
  border-radius: 5px;
  text-align: left;
  color: #304fa9;
}

.card-details-benefits {
  width: 100%;
  padding: 30px 0;
  text-align: center;
  border-bottom: 1px solid #f3f3f3;
}

.card-title-prices {
  padding: 33px 0;
  color: #131e3f;
  margin-top: 7px;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  background-color: #f1f3fd;
  text-transform: uppercase;
  text-align: center;
}

.card-details-prices {
  width: 100%;
  padding: 32px 0;
  text-align: center;
  border-bottom: 1px solid #f3f3f3;
}

.card-button-prices {
  border-radius: 8px;
  color: #fff !important;
  font-weight: 500;
  text-transform: none;
  background: #4874f1;
}

.card-button-current-plan {
  border-radius: 8px;
  color: #304fa9 !important;
  font-weight: 500;
  text-align: left;
  text-transform: none;
  background: #efeffd !important;
  cursor: default;
  pointer-events: none;
  -webkit-pointer-events: none;
}

.card-price {
  margin-bottom: 10px;
}

.chosen-card .card-price {
  border-radius: 8px;
  /*box-shadow: 0px 0px 20px rgba(18, 25, 43, 0.05);*/
  background: #ffffff;
  height: 365px;
  border: 1.5px solid #f0f3f3;
  font-size: 16px;
  margin-bottom: 0;
  position: relative;
}

.chosen-card .card-price .card-title-prices {
  background: #304fa9;
  color: #fff;
  margin-top: 0px;
  border-radius: 8px 8px 0 0;
}

.chosen-card .card-price .card-details-prices {
  border-bottom: none;
}

.slide-prev {
  display: block !important;
  top: 224px !important;
  z-index: 9999 !important;
  position: relative !important;
  right: 51% !important;
  width: 52px;
  height: 52px;
  cursor: pointer;
  border-radius: 100px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgb(18 25 43 / 12%);
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.slide-next {
  display: block !important;
  bottom: 245px !important;
  z-index: 9999 !important;
  position: relative !important;
  left: 51% !important;
  width: 52px;
  height: 52px;
  cursor: pointer;
  border-radius: 100px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgb(18 25 43 / 12%);
}

.slide-next-svg,
.slide-prev-svg {
  margin: 16px;
}

.col-carousel-prices::after {
  height: 468px;
  width: 83px;
  right: 1px;
  content: '';
  background: linear-gradient(
    270.49deg,
    #ffffff 0.44%,
    rgba(255, 255, 255, 0.803339) 30.74%,
    rgba(255, 255, 255, 0) 85.57%
  );
  position: relative;
  display: flex;
  bottom: 50%;
  left: 92%;
}

.col-carousel-prices.currentStateGradient::after {
  display: none;
}
</style>

<style lang="scss">
@import '~vuetify/src/components/VStepper/_variables.scss';

.slide-group-prices .v-slide-group__next--disabled,
.slide-group-prices .v-slide-group__prev--disabled {
  visibility: hidden !important;
}

.slide-group-prices .v-slide-group__next,
.slide-group-prices .v-slide-group__prev {
  height: 0;
}

.v-dialog--active {
  overflow: hidden;
}
</style>
